import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { timeout, tap } from 'rxjs/operators';
import { BBResponseContainer } from './response-container';

//This is the service to authenticate user
@Injectable()
export class AuthenticationService {
    
    constructor(private http: HttpClient) { }

    login(username: string, password: string) {

        let url = environment.BB_APIGATEWAY_SERVICE_URL + 'auth/login';
        return this.http.post<BBResponseContainer>(url, { username: username, password: password })
        .pipe(timeout(environment.defaultTimeout)
        ,tap(
            event => {                
                if (event && event.data) {                   
                    localStorage.setItem('currentUser', event.data);
                }
             }, 
            error => {
                if (error.status === 401) {
                    localStorage.removeItem('currentUser');
                    console.log("API authentication failed: " + error.status);
                }
                error.url = url;
        }));      
    }

    logout() {
        localStorage.removeItem('currentUser');
    }
}